import { TdDataTableSortingOrder } from '@covalent/core';

export class Utils {

    // Compares two string dates, ignoring time.
    public static datesWithinRange(from: string, to: string, check: string): boolean {

        let result: boolean = (Date.parse(check.substr(0, 10)) <= Date.parse(to.substr(0, 10))) &&
            (Date.parse(check.substr(0, 10)) >= Date.parse(from.substr(0, 10)));

        //console.log('is: ' + check + ' within range from: ' + from + ', to: ' + to + '? ' + result);

        return result;

    }

    public static dateLessThan(setDate: string, check: string): boolean {
        let result: boolean = (Date.parse(check.substr(0, 10)) < Date.parse(setDate.substr(0, 10)));

        //console.log('is: ' + check + ' less than: ' + setDate + '? ' + result);
        return result;
    }


    // Fixes the covalent sort data function by checking for isFinite() on numbers, without which dates were parsed and sorted as numbers
    public static sortData(data: any[], sortBy: string, sortOrder: TdDataTableSortingOrder): any[] {
        console.log("Sort list by: " + sortBy + ", sortOrder:" + sortOrder);
        if (sortOrder === void 0) { sortOrder = TdDataTableSortingOrder.Ascending; }
        if (sortBy) {
            data.sort(function (a, b) {
                var compA = a[sortBy];
                var compB = b[sortBy];
                var direction = 0;

                //console.log(compA + " is a number? " + (!Number.isNaN(Number.parseFloat(compA)) && isFinite(compA)));
                //console.log(compB + " is a number? " + (!Number.isNaN(Number.parseFloat(compB)) && isFinite(compB)));

                if (!Number.isNaN(Number.parseFloat(compA)) && isFinite(compA) && !Number.isNaN(Number.parseFloat(compB)) && isFinite(compB)) {
                    //console.log("direction: " + (Number.parseFloat(compA) - Number.parseFloat(compB)));
                    direction = Number.parseFloat(compA) - Number.parseFloat(compB);
                }
                else {

                    //console.log("A: " + compA + ", B: " + compB);
                    if ((!compA && compB) || (compA < compB)) {
                        //console.log("A < B");
                        direction = -1;
                    }
                    else if ((compA && !compB) || (compA > compB)) {
                        //console.log("A > B");
                        direction = 1;
                    }
                }
                return direction * (sortOrder === TdDataTableSortingOrder.Descending ? -1 : 1);
            });
        }
        return data;
    }
}


// WEBPACK FOOTER //
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/src/app/shared/utils.ts